import _asyncToGenerator from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/regenerator";
import browserStore from '@anm/helpers/browserStore';
import isServer from '@anm/helpers/is/isServer';
import { getParamsFromSearch } from '@anm/hooks/usePageParams';
import { ClientCommand } from './types';
export var isSemrushIframe = function isSemrushIframe() {
  return !isServer() && window.name === 'semrush_iframe';
};
export var isSemrushIframeWithProps = function isSemrushIframeWithProps() {
  var _getParamsFromSearch = getParamsFromSearch(),
      isSemrush = _getParamsFromSearch.isSemrush;

  return isSemrush === 'true' ? true : isSemrushIframe();
};
export var pushUrl = function pushUrl(url) {
  return window.SM.client(ClientCommand.pushUrl, url);
};
export var replaceUrl = function replaceUrl(url) {
  return window.SM.client(ClientCommand.replaceUrl, url);
};
export var getAccessToken = function getAccessToken() {
  return window.SM.client(ClientCommand.getAccessToken);
};
export var requestPurchase = function requestPurchase() {
  var semrushAppId = getAppId();
  console.log('requestInAppPurchase ', semrushAppId, window.SM);
  semrushAppId && window.SM.client(ClientCommand.requestInAppPurchase, [semrushAppId]);
};
export var load = function load() {
  return new Promise(function (resolve) {
    /* tslint:disable */
    (function (d, e, v, t, s) {
      t = d.createElement(e);
      t.type = 'text/javascript';
      t.async = true;
      t.src = v;

      t.onload = function () {
        resolve('OK');
      };

      s = d.getElementsByTagName('body')[0];
      s.append(t);
    })(document, 'script', 'https://static.semrush.com/app-center/sdk.js');
  });
};
export var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appId && setAppId(appId);
            _context.next = 3;
            return window.SM.init();

          case 3:
            console.log('Semrush configs ', window.SM.config);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init(_x) {
    return _ref.apply(this, arguments);
  };
}();
var AppIdKey = 'SemrushAppId';

var setAppId = function setAppId(appId) {
  return browserStore.set(AppIdKey, appId);
};

var getAppId = function getAppId() {
  return browserStore.get(AppIdKey);
};